import { render, staticRenderFns } from "./NewsCategoryBtns.vue?vue&type=template&id=68255d63&"
import script from "./NewsCategoryBtns.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports